import Vue from "vue";
import base from "../../baseMarketing";

export default Object.assign(
    {
        apiUrl: "/email",

        async create({             
          configuration,
          id,
          isAutomationFlow,
          schedulerDate,
          sendType,
          sourceNote,
          status,
          title, 
          senderEmail,
          senderName,
          brief,
          subject,
          cssStyle,
          editorType,
          rawContent
        }) {          
          const url = this.userUrl({ path: `/` });

          return Vue.http.post(url, {
            configuration,
            id,
            isAutomationFlow,
            schedulerDate,
            sendType,
            sourceNote,
            status,
            title, 
            senderEmail,
            senderName,
            brief,
            subject,
            cssStyle,
            editorType,
            rawContent
          });
        },

        async edit({
          emailId,
          validateSender = false,
          data: {
            brief,
            configuration,
            id,
            isAutomationFlow,
            schedulerDate,
            sendType,
            senderEmail,
            senderName,
            sourceNote,
            status,
            subject,
            title,
            cssStyle,
            editorType,
            rawContent
          }             
        }) {
          const url = this.userUrl({ path: `/${emailId}?validateSender=${validateSender}` });

          return Vue.http.put(url, {
            configuration,
            id,
            isAutomationFlow,
            schedulerDate,
            sendType,
            sourceNote,
            status,
            title, 
            senderEmail,
            senderName,
            brief,
            subject,
            cssStyle,
            editorType,
            rawContent
          });
        },

        async setSendType({
          emailId,
          type,
          file,
          sourceNote,
          configurationSimplesSegmentedList,
      }) {
          const typeString = {
              ["EXTERNAL"]: "external",
              ["SIMPLE_SEGMENTED_LIST"]: "simple-segmented-list",
              ["WHOLE_DATABASE"]: "whole-database",
              ["CUSTOM_SEGMENTED_LIST"]: "custom-segmented-list",
          }[type];

          const url = this.userUrl({
              path: `/${emailId}/sendtype/${typeString}`,
          });

          let data = {};

          if (type === "EXTERNAL") {
              const options = {
                  headers: {
                      "Content-Type": "multipart/form-data",
                  },
              };

              const data = new FormData();
              data.append("file", file);
              data.append("note", sourceNote);

              return Vue.http.post(url, data, options);
          }

          if (type === "SIMPLE_SEGMENTED_LIST") {
              data.configurationSimplesSegmentedList =
                  configurationSimplesSegmentedList;
          }

          if (type === "CUSTOM_SEGMENTED_LIST") {
              data = configurationSimplesSegmentedList;
          }

          return Vue.http.put(url, data);
      },

      async list({ page = 0, filter, isAutomation }) {
        const url = this.userUrl({ path: `/${page}/list` });

        return Vue.http.get(url, {
            params: {
                filter,
                isAutomation
            },
        });
      },

      async duplicate({ isAutomation, emailId }) {
        const url = this.userUrl({ path: `/${emailId}/copy` });

        return Vue.http.post(url, {
            isAutomation,
        });
      },

      async delete({ emailId }) {
        const url = this.userUrl({ path: `/${emailId}` });

        return Vue.http.delete(url);
      },

      async get({ emailId }) {
        const url = this.userUrl({ path: `/${emailId}` });

        return Vue.http.get(url);
      },

      async templates() {
        const url = this.url(`/templates`);

        return Vue.http.get(url);
      },

      async credentials() {
        return Vue.http.get('/marketing/stripo/credentials');
      },

      async compile({ emailId, credentials }) {
        const url = this.userUrl({ path: `/${emailId}/compile` });

        return Vue.http.put(url, credentials,  {
          headers: {
              "Content-Type": "text/plain",
          },
        });
      },
    },
    base
);
